export const REDUCER_NAME = "orderSlice";


export interface EmployeeOrderProduct {
  id: string;
  name: string;
  category: string;
  currency: string;

  
  price: string;                 
  shippingPrice: string;        
  internationalshippingPrice: string; 
  discount: string;             
  taxesAndCharges: string;      
  taxOptions: string;           

  costPrice: number;
  sellingPrice: number;
  packagingCharges: number;
  quantity: number;

  image: string | null;
  images: string[];

  resellerName: string;
  wholesellerName: string;

 
  sizes: string;
}

export interface EmployeeOrderAddress {
  id: string;
  order_id: string;

  name: string;
  mobile_number: string;

  country: string;
  state: string;
  city: string;
  zip_code: string;
  street_address: string;

  email?: string | null;
  gstNumber?: string | null;
}

export interface EmployeeOrder {
  id: string;

  orderId: string;
  customerId: string;

  name: string;
  email: string | null;
  avatar: string | null;

  items: number;
  price: string;

  status: string | null;

  forward: boolean;
  orderForwarded: number;
  wholesalerCount: number;

  refrenceNumber: string | null;

  createdAt: string;
  updatedAt: string;

  products: EmployeeOrderProduct[];
  shippingAddress: EmployeeOrderAddress;
}


export interface EmployeeOrderListPayload {
  message: string;
  orders: EmployeeOrder[];
}


export interface iOrderState {
  isLoading: boolean;
  errorMessage: string | null;

  
 
  EmployeesOrderList: EmployeeOrder[];

  
  orders: EmployeeOrder | null;

  forwardItems: null;
}
